import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HomeFooterSectionComponent } from '../home-page/components/home-footer-section/home-footer-section.component';
import { HomeHeaderSectionComponent } from '../home-page/components/home-header-section/home-header-section.component';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [RouterModule, HomeFooterSectionComponent, HomeHeaderSectionComponent],
  templateUrl: './public-layout.html',
  styleUrl: './public-layout.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicLayoutComponent {}

